module.exports = __webpack_public_path__ + "1d25cc06dee32c022dee3d639f25a2dd.glb";